import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tailwind.css';
import './styles/konfigurator.css';
import './styles/forms.css';
// Direction A — drafting-sheet type system, reset, and utility classes.
// MUST load last so its `.skyvision-konfigurator :where(...)` rules and
// !important resets can override the legacy stylesheets above during the
// migration from the old brand-font look to Direction A.
import './styles/typography.css';
import { registerServiceWorker, showUpdateNotification } from './services/serviceWorkerRegistration';

// Interface für Konfigurator-Konfiguration
interface KonfiguratorConfig {
  products: string;
  showVisualizer: boolean;
  theme: string;
  compact: boolean;
}

// Alle möglichen Konfigurator-Container
const configuratorIds = [
  'skyvision-konfigurator',
  'skyvision-fixed',
  'skyvision-comfort',
  'skyvision-circular',
  'skyvision-circular-walkon',
  'skyvision-walkon',
  'skyvision-linear',
  'skyvision-linear-walkon',
  'skyvision-access',
  'skyvision-simple'
];

// Funktion zum Lesen der data-Attribute
function getConfigFromElement(element: Element): KonfiguratorConfig {
  return {
    products: element.getAttribute('data-products') || 'all',
    showVisualizer: element.getAttribute('data-show-visualizer') !== 'false',
    theme: element.getAttribute('data-theme') || 'default',
    compact: element.getAttribute('data-compact') === 'true'
  };
}

// Service Worker registrieren für Offline-Modus
registerServiceWorker({
  onSuccess: () => {
    console.log('App ist bereit für Offline-Nutzung');
  },
  onUpdate: (registration) => {
    console.log('Neue Version verfügbar');
    showUpdateNotification(registration);
  },
  onOffline: () => {
    console.log('App ist offline');
    // Optional: Zeige Offline-Banner
  },
  onOnline: () => {
    console.log('App ist wieder online');
    // Optional: Verstecke Offline-Banner
  }
});

// Alle Konfigurator-Container finden und initialisieren
configuratorIds.forEach(id => {
  const container = document.getElementById(id);
  if (container) {
    const config = getConfigFromElement(container);
    const root = createRoot(container);
    
    root.render(
      <React.StrictMode>
        <App config={config} containerId={id} />
      </React.StrictMode>
    );
  }
}); 